//正式服务器地址及图片地址
import da from "element-ui/src/locale/lang/da";

export let FormalUrl = 'http://bjyijie.com.cn';
export let ImgUrl = FormalUrl + '/yijie/upload/img/';
export let OSSImgUrl = 'https://bj-yijie.oss-cn-hangzhou.aliyuncs.com/';

//引入axios
import axios from 'axios';

//引入node中的qs,用于序列化参数
import Qs from 'qs';

//创建axios实例，并自定义配置
const _axios = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // baseURL: '/api',
    timeout: 180000,    //请求超时时间，单位：毫秒
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
});

//封装get请求
export const ajax_get = (url, data = {}) => {
    data.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
    return _axios.get(url, {
        params: data
    }).then(result => {
        return ajax_aftet(result);
    })
}

//封装POST请求
export const ajax_post = (url, data = {}) => {
    return _axios.post(url, Qs.stringify(data)).then(result => {
        return ajax_aftet(result)
    })
}

//在数据请求回来之后的公共判断
let ajax_aftet = (result) => {
    return new Promise((resolve, reject) => {
        if (result.status == 200) {
            if (result.data.rescode == '200') {
                resolve(result.data);
            } else {
                reject(result.data);
            }
        } else {
            // Vue.$fbmessage.error('网络错误');
            reject(result.data);
        }
    })
}
